import angular from 'angular';
import ckeditorConfig, { initializeCss } from '@/ckeditorConfig';

angular.module('cloudX').directive('cxCkeditor', [
  '$compile',
  function($compile) {
    return {
      restrict: 'E',
      require: 'ngModel',
      scope: {
        options: '=?',
        readonly: '=?',
        noToolbar: '=?',
      },
      link: function(scope, element, attrs) {
        var id = attrs.key ? scope.$eval(attrs.key) || attrs.key : '';
        var name = attrs.name ? scope.$eval(attrs.name) || attrs.name : '';
        var ngModel = attrs.ngModel;
        var newEl = angular.element(
          `<div ng-class="{'no-toolbar-ckeditor':noToolbar, 'readonly-ckeditor':readonly}"> <div ckeditor="vm.ckeOptions"
                id="${id}"
                name="${name}"
                ng-readonly="readonly"
                ng-model="$parent.${ngModel}"></div></div>`,
        );

        $compile(newEl)(scope); // Only compile the new element
        element.append(newEl);
      },
      controllerAs: 'vm',
      controller: [
        '$scope',
        '$translate',
        function($scope, $translate) {
          var vm = this;
          vm.$onInit = function() {
            initializeCss(true);
            vm.ckeOptions = angular.extend(
              {},
              ckeditorConfig(true),
              {
                language: $translate.use(),
                fullPage: true,
              },
              $scope.options,
            );
          };
        },
      ],
    };
  },
]);
